import React, { useState } from 'react';
import axios from 'axios';
import { API } from './shared';

const T = {
  el: { title: 'Συνομιλία με τη διαχείριση', you: 'Εσείς', mgmt: 'MIC Pieri Management Committee', ph: 'Γράψτε την απάντησή σας…', send: 'Αποστολή απάντησης', sending: 'Αποστολή…', sent: 'Η απάντησή σας καταχωρίστηκε.', closed: 'Η συνομιλία έχει ολοκληρωθεί.', error: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά.' },
  en: { title: 'Conversation with management', you: 'You', mgmt: 'MIC Pieri Management Committee', ph: 'Write your reply…', send: 'Send reply', sending: 'Sending…', sent: 'Your reply has been registered.', closed: 'This conversation has been closed.', error: 'Something went wrong. Please try again.' },
};

export const PublicConversation = ({ token, lang, conversation, intro }) => {
  const t = T[lang];
  const [conv, setConv] = useState(conversation);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const send = async () => {
    if (busy || text.trim().length < 2) return;
    setBusy(true); setMsg('');
    try {
      const r = (await axios.post(`${API}/public/owner-feedback/${token}/message`, { text }, { withCredentials: false })).data;
      setConv(r.conversation); setText(''); setMsg(t.sent);
    } catch (e) { setMsg(e.response?.data?.detail === 'conversation_closed' ? t.closed : t.error); } finally { setBusy(false); }
  };
  return (
    <div data-testid="pf-conversation">
      {intro && <p className="text-sm text-emerald-700 font-medium mb-4" data-testid="pf-conversation-intro">{intro}</p>}
      <div className="text-[10px] uppercase tracking-wider text-zinc-500 mb-2">{t.title}</div>
      <div className="space-y-2">
        {conv.messages.map((m, i) => (
          <div key={i} className={`border-l-2 pl-3 py-1 ${m.from === 'owner' ? 'border-zinc-400' : 'border-emerald-500 bg-emerald-50/50'}`} data-testid={`pf-msg-${i}`}>
            <div className="text-[11px] font-semibold text-zinc-600">{m.from === 'owner' ? t.you : t.mgmt} · {m.at ? new Date(m.at).toLocaleString('el-GR') : ''}</div>
            <div className="text-sm whitespace-pre-wrap">{m.text}</div>
          </div>))}
      </div>
      {conv.can_reply ? (
        <div className="mt-4">
          <textarea rows={4} maxLength={5000} placeholder={t.ph} className="w-full border border-zinc-300 p-3 text-sm focus:outline-none focus:border-zinc-900" value={text} onChange={(e) => setText(e.target.value)} data-testid="pf-reply-text" />
          <button type="button" onClick={send} disabled={busy || text.trim().length < 2} className="mt-2 w-full bg-zinc-900 text-white py-3 font-semibold hover:bg-zinc-800 transition-colors disabled:opacity-60" data-testid="pf-reply-send">{busy ? t.sending : t.send}</button>
        </div>) : <p className="text-sm text-zinc-500 mt-4" data-testid="pf-conversation-closed">{t.closed}</p>}
      {msg && <p className="text-sm mt-2 text-zinc-700" data-testid="pf-reply-msg">{msg}</p>}
    </div>
  );
};

export default PublicConversation;
